import React, {useEffect, useState, useRef} from 'react';
import {useHistory, Link} from 'react-router-dom';
import useAnimate from '../../hooks/useAnimate';
// import material ui
import {
  makeStyles,
  useMediaQuery,
  useTheme,
  Tooltip,
  IconButton,
} from '@material-ui/core';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Collapse,
  Box,
} from '@mui/material';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import {MuiPickersUtilsProvider, DatePicker} from '@material-ui/pickers';
// import i18n
import {useTranslation} from 'react-i18next';
// import components
import DashboardButtonBack from '../../_components/DashboardButtonBack';
import DashboardAnimate from '../../_components/DashboardAnimate';
import PrintOrder from './components/PrintOrder';
import Preloader from '../../_components/Preloader';
import DashboardBanner from '../../_components/DashboardBanner';
// redux
import {store} from '../../_helpers';
import {connect} from 'react-redux';
import {userActions} from '../../_actions';
// import moment
import moment from 'moment';
// import for print
import {useReactToPrint} from 'react-to-print';
// date io
import DateFnsUtils from '@date-io/date-fns';
import ukLocale from 'date-fns/locale/uk';
import ruLocale from 'date-fns/locale/ru';
import enLocale from 'date-fns/locale/en-US';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 1246,
    margin: '0 auto',
    padding: '0 15px',
    overflowX: 'hidden',
  },

  body: {
    padding: '50px 0 30px 0',
    [theme.breakpoints.down(768)]: {
      padding: '30px 0 15px 0',
    },
  },

  item: {
    paddingTop: 32,
    paddingBottom: 32,
    [theme.breakpoints.down(476)]: {
      paddingTop: 16,
      paddingBottom: 16,
    },
  },

  itemDisabled: {
    paddingTop: 32,
    paddingBottom: 32,
    height: '40vh',
    [theme.breakpoints.down(476)]: {
      paddingTop: 16,
      paddingBottom: 16,
    },
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '15px',
  },

  content: {
    display: 'grid',
    gap: 32,
    [theme.breakpoints.down(960)]: {
      gap: 15,
    },
  },

  back: {
    paddingBottom: '50px',
    [theme.breakpoints.down(768)]: {
      paddingBottom: '30px',
    },
  },

  tableDisabled: {
    position: 'relative',
    paddingTop: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    height: '400px',
    '&::-webkit-scrollbar': {
      width: 3,
      height: 3,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#ccc',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#8E95A9',
      borderRadius: 10,
    },
    '& table thead th:first-child': {
      maxWidth: '50px',
      boxSizing: 'border-box',
    },
    '& table tbody td:first-child': {
      maxWidth: '50px',
      boxSizing: 'border-box',
    },
    '& table thead th:nth-child(2)': {
      textAlign: 'left',
    },
    '& table tbody td:nth-child(2)': {
      textAlign: 'left',
    },
    '& table tbody td': {
      color: '#555F7E',
    },
  },

  table: {
    position: 'relative',
    paddingTop: 24,
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: 3,
      height: 3,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#ccc',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#8E95A9',
      borderRadius: 10,
    },
    '& table thead th:first-child': {
      maxWidth: '50px',
      boxSizing: 'border-box',
    },
    '& table tbody td:first-child': {
      maxWidth: '50px',
      boxSizing: 'border-box',
    },
    '& table thead th:nth-child(2)': {
      textAlign: 'left',
    },
    '& table tbody td:nth-child(2)': {
      textAlign: 'left',
    },
    '& table tbody td': {
      color: '#555F7E',
    },
  },

  input: {
    width: 340,
    padding: '12px 50px 12px 25px',
    boxSizing: 'border-box',
    border: '1px solid #C8CAD8',
    borderRadius: '50px',
    color: 'black',
    fontSize: 13,
    fontWeight: 400,

    '&::placeholder': {
      color: '#C8CAD8',
    },
    [theme.breakpoints.down(600)]: {
      width: '100%',
    },
  },

  button: {
    backgroundColor: 'transparent',
    border: 0,
    color: '#555F7E',
    padding: 0,
    cursor: 'pointer',
    transition: '0.3s',

    '&:hover': {
      color: '#000',
    },
  },

  more_table: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    '& tbody': {
      borderBottom: '1px solid #CDD1DE',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '10px',

    '& button': {
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },

    '& a': {
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
  },

  print: {
    position: 'absolute',
    display: 'none',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#fff',
    width: '70vw',
    height: '70vh',
    zIndex: 999,
  },

  datePicker: {
    '& input': {
      textAlign: 'center',
    },
  },

  customDateInput: {
    '& input': {
      textAlign: 'center',
      border: 'none',
      borderRadius: 4,
      padding: '8px 12px',
      cursor: 'pointer',
      fontSize: 15,
      width: 'max-content',
    },
  },
}));

const localeMap = {
  en: enLocale,
  uk: ukLocale,
  ru: ruLocale,
};

const getStatusColors = (statusId, isNovaPoshta) => {
  if (isNovaPoshta) {
    if (statusId === 2) {
      return {
        color: '#2F80ED',
        bg: '#EAF2FF',
        border: '#EAF2FF',
      };
    }

    if (statusId === 22) {
      return {
        color: '#27AE60',
        bg: '#E9F7EF',
        border: '#E9F7EF',
      };
    }
  }

  switch (statusId) {
    case 2:
      return {
        color: '#2F80ED',
        bg: '#EAF2FF',
        border: '#EAF2FF',
      };
    case 22:
      return {
        color: '#F2994A',
        bg: '#FFF4E5',
        border: '#FFF4E5',
      };
    case 23:
      return {
        color: '#27AE60',
        bg: '#E9F7EF',
        border: '#E9F7EF',
      };
    case 24:
      return {
        color: '#EB5757',
        bg: '#FDECEC',
        border: '#FDECEC',
      };
    default:
      return {
        color: '#555F7E',
        bg: 'transparent',
        border: '#CDD1DE',
      };
  }
};

const Row = props => {
  const {data} = props;
  const {
    id,
    order_items,
    delivery,
    delivery_type,
    delivery_type_name,
    created,
    status_name,
    nova_post_document_number,
    seats_amount,
    remark,
    payment,
    date_scheduled_delivery,
    full_date_scheduled_delivery,
  } = data;

  const classes = useStyles();
  const {t} = useTranslation();
  const [open, setOpen] = useState(false);

  // logic print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const onDownload = e => {
    e.stopPropagation();
    handlePrint();
  };

  const isNovaPoshta = remark?.delivery_service === 'Нова Пошта';

  const statusColors = getStatusColors(status_name?.id, isNovaPoshta);

  const editIcon = () => {
    return (
      <Link to={`/dashboard/ttn-create/${id}`}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 13.3335H14"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 2.33316C11.2652 2.06794 11.6249 1.91895 12 1.91895C12.1857 1.91895 12.3696 1.95553 12.5412 2.0266C12.7128 2.09767 12.8687 2.20184 13 2.33316C13.1313 2.46448 13.2355 2.62038 13.3066 2.79196C13.3776 2.96354 13.4142 3.14744 13.4142 3.33316C13.4142 3.51888 13.3776 3.70277 13.3066 3.87435C13.2355 4.04593 13.1313 4.20184 13 4.33316L4.66667 12.6665L2 13.3332L2.66667 10.6665L11 2.33316Z"
            stroke="#C8CAD8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Link>
    );
  };

  return (
    <>
      <TableBody
        onClick={() => setOpen(!open)}
        sx={{backgroundColor: open ? '#F5F7FB' : 'unset'}}>
        <TableRow
          style={{
            backgroundColor: statusColors.bg,
            borderBottom: `1px solid ${statusColors.border}`,
          }}>
          <TableCell>
            <IconButton aria-label="expand row" size="small">
              {open ? (
                <KeyboardArrowUpIcon style={{color: '#008CB4'}} />
              ) : (
                <KeyboardArrowDownIcon style={{color: '#C8CAD8'}} />
              )}
            </IconButton>
          </TableCell>
          <TableCell>#{id}</TableCell>
          <TableCell>{data?.warehouse_name}</TableCell>
          <TableCell>
            {delivery_type === 'delivery_service'
              ? remark?.delivery_service
              : delivery_type_name}
          </TableCell>
          <TableCell
            style={{
              color: statusColors.color,
            }}>
            {created}
          </TableCell>
          <TableCell>
            {full_date_scheduled_delivery ?? date_scheduled_delivery ?? '-'}
          </TableCell>
          <TableCell
            style={{
              color: statusColors.color,
            }}>
            {status_name?.name}
            {/* {nova_post_document_number ? 'Виконано' : 'Прийнято в обробку'} */}
          </TableCell>
          <TableCell>
            <Box className={classes.actions}>
              <Tooltip style={{padding: 0}} title={t('common:download')}>
                <IconButton>
                  <button onClick={onDownload}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM0 16V11H2V14H14V11H16V16H0Z"
                        fill="#C8CAD8"
                      />
                    </svg>
                  </button>
                </IconButton>
              </Tooltip>
              {editIcon()}
            </Box>
          </TableCell>
        </TableRow>
        <TableRow
          style={{
            backgroundColor: statusColors.bg,
            width: '100%',
          }}>
          <TableCell
            style={{paddingBottom: 0, paddingTop: 0, width: '100%'}}
            colSpan={8}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(1, 1fr)',
                  gap: '15px',
                  padding: '16px 0',
                }}>
                {delivery_type === 'delivery_service' &&
                  remark?.delivery_service === 'Нова Пошта' && (
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(1, 1fr)',
                        gap: '4px',
                        textAlign: 'left',
                        padding: '12px 16px',
                        backgroundColor: '#fff',
                      }}>
                      <p className="dashboard-text">
                        <span style={{color: '#1C2A53'}}>
                          {t('common:TTN_number')}:
                        </span>{' '}
                        {nova_post_document_number || '-'}
                      </p>
                      <p className="dashboard-text">
                        <span style={{color: '#1C2A53'}}>
                          {t('common:quantity_items_label')}:
                        </span>{' '}
                        {seats_amount || '1'}
                      </p>
                    </Box>
                  )}
                {order_items?.length > 0 && (
                  <Table
                    size="small"
                    aria-label="purchases"
                    className={classes.more_table}>
                    {order_items?.map((item, index) => (
                      <TableBody key={`order-product-${index}`}>
                        <TableRow>
                          <TableCell
                            style={{
                              whiteSpace: 'nowrap',
                              maxWidth: 'fit-content',
                            }}>
                            {item?.brand}
                          </TableCell>
                          <TableCell
                            style={{textAlign: 'center', whiteSpace: 'nowrap'}}>
                            {item?.article}
                          </TableCell>
                          <TableCell>{item?.name}</TableCell>
                          <TableCell style={{whiteSpace: 'nowrap'}}>
                            {item?.quantity} шт.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ))}
                  </Table>
                )}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </TableBody>
      {data && (
        <div className={classes.print}>
          <PrintOrder data={data} ref={componentRef} />
        </div>
      )}
    </>
  );
};

const DashboardStorekeeper = props => {
  const {userSelectedData, warehouseman, getWarehouseman} = props;
  useAnimate();
  const getParams = new URLSearchParams(window.location.search);
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const {t} = useTranslation();
  const [valueDate, setValueDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isRangeMode, setIsRangeMode] = useState(false);
  const [tempSelectedDate, setTempSelectedDate] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [activeWarehouseId, setActiveWarehouseId] = useState(null);
  const [activeStatusId, setActiveStatusId] = useState(0);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.up(600), {
    defaultMatches: true,
  });

  const statusOptions = [
    {id: 0, label: 'Всі статуси', color: '#555F7E', bg: '#F5F7FB'},
    {id: 2, label: 'Прийнято', color: '#2F80ED', bg: '#EAF2FF'},
    {id: 22, label: 'Сформовано', color: '#F2994A', bg: '#FFF4E5'},
    {id: 23, label: 'Виконано', color: '#27AE60', bg: '#E9F7EF'},
    {id: 24, label: 'Скасовано', color: '#EB5757', bg: '#FDECEC'},
  ];

  const currentStatus =
    statusOptions.find(s => s.id === activeStatusId) || statusOptions[0];

  // get lang
  const state = store.getState();
  const {languageReducer} = state;
  let lang = 'uk';
  if (languageReducer.ln_ch !== undefined) lang = languageReducer.ln_ch;

  useEffect(() => {
    const dateParam = getParams.get('date');
    const startParam = getParams.get('start_date');
    const endParam = getParams.get('end_date');
    const statusParam = getParams.get('status');
    
    if (statusParam) {
      setActiveStatusId(Number(statusParam));
    }

    if (startParam && endParam) {
      setIsRangeMode(true);
      setStartDate(moment(startParam, 'DD-MM-YYYY'));
      setEndDate(moment(endParam, 'DD-MM-YYYY'));
    } else if (dateParam) {
      setIsRangeMode(false);
      setValueDate(moment(dateParam, 'DD-MM-YYYY'));
    } else {
      setValueDate(moment());
    }
  }, []);

  useEffect(() => {
    if (isRangeMode && startDate && endDate) {
      getParams.set('start_date', moment(startDate).format('DD-MM-YYYY'));
      getParams.set('end_date', moment(endDate).format('DD-MM-YYYY'));
      getParams.set('status', activeStatusId);
      getParams.delete('date');
      setActiveWarehouseId(null);
      history.push({search: getParams.toString()});

      getWarehouseman({
        customerId: userSelectedData.customer_id,
        filter_status: activeStatusId,
        filter_range_date_start: moment(startDate).format('DD.MM.YYYY'),
        filter_range_date_end: moment(endDate).format('DD.MM.YYYY'),
      });
    } else if (!isRangeMode && valueDate) {
      getParams.set('date', moment(valueDate).format('DD-MM-YYYY'));
      getParams.delete('start_date');
      getParams.delete('end_date');
      getParams.set('status', activeStatusId);
      setActiveWarehouseId(null);
      history.push({search: getParams.toString()});

      getWarehouseman({
        customerId: userSelectedData.customer_id,
        filter_status: activeStatusId,
        filter_date: moment(valueDate).format('DD.MM.YYYY'),
      });
    }
  }, [valueDate, startDate, endDate, isRangeMode, activeStatusId]);

  const handleDateChange = date => {
    if (!tempSelectedDate) {
      setTempSelectedDate(date);
      setValueDate(date);
      setIsRangeMode(false);
    } else {
      if (moment(date).isSame(tempSelectedDate, 'day')) {
        setValueDate(date);
        setTempSelectedDate(null);
        setIsRangeMode(false);
      } else {
        const start = moment(date).isBefore(tempSelectedDate)
          ? date
          : tempSelectedDate;
        const end = moment(date).isBefore(tempSelectedDate)
          ? tempSelectedDate
          : date;

        setStartDate(start);
        setEndDate(end);
        setIsRangeMode(true);
        setTempSelectedDate(null);
      }
    }
  };

  const getDisplayValue = () => {
    if (isRangeMode && startDate && endDate) {
      return `${moment(startDate).format('DD.MM.YYYY')} - ${moment(
        endDate,
      ).format('DD.MM.YYYY')}`;
    }
    return valueDate
      ? moment(valueDate).format('DD.MM.YYYY')
      : moment().format('DD.MM.YYYY');
  };

  useEffect(() => {
    if (!warehouseman?.orders) {
      setActiveWarehouseId(null);
      return
    }

    const uniqueWarehouses = Array.from(
      new Map(
        warehouseman.orders
          .filter(o => o?.warehouse_id && o?.warehouse_name)
          .map(o => [
            o.warehouse_id,
            {
              warehouse_id: o.warehouse_id,
              warehouse_name: o.warehouse_name,
            },
          ]),
      ).values(),
    );

    setWarehouses(uniqueWarehouses);
  }, [warehouseman?.orders]);

  const filteredOrders =
    warehouseman?.orders?.filter(order => {
      if (!activeWarehouseId) return true;
      return order?.warehouse_id === activeWarehouseId;
    }) || [];

  return (
    <main className="dashboard">
      <DashboardBanner />
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.back}>
            <DashboardButtonBack />
          </div>
          <DashboardAnimate style={{transform: 'scale(0.97)'}}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 16,
                marginBottom: 24,
                flexWrap: 'wrap',
              }}>
              {warehouses.length > 0 ? (
                <div
                  style={{
                    display: 'flex',
                    gap: 12,
                    flexWrap: 'wrap'
                  }}>
                  <div
                    onClick={() => setActiveWarehouseId(null)}
                    style={{
                      padding: '8px 16px',
                      borderRadius: 20,
                      cursor: 'pointer',
                      backgroundColor:
                        activeWarehouseId === null ? '#FFBE00' : '#F5F7FB',
                      color: activeWarehouseId === null ? '#fff' : '#1C2A53',
                      fontSize: 13,
                      fontWeight: 500,
                    }}>
                    Всі склади
                  </div>

                  {warehouses.map(warehouse => (
                    <div
                      key={warehouse.warehouse_id}
                      onClick={() =>
                        setActiveWarehouseId(warehouse.warehouse_id)
                      }
                      style={{
                        padding: '8px 16px',
                        borderRadius: 20,
                        cursor: 'pointer',
                        backgroundColor:
                          activeWarehouseId === warehouse.warehouse_id
                            ? '#FFBE00'
                            : '#F5F7FB',
                        color:
                          activeWarehouseId === warehouse.warehouse_id
                            ? '#fff'
                            : '#1C2A53',
                        fontSize: 13,
                        fontWeight: 500,
                      }}>
                      {warehouse.warehouse_name}
                    </div>
                  ))}
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    gap: 12,
                    flexWrap: 'wrap'
                  }}>
                  <div
                    onClick={() => setActiveWarehouseId(null)}
                    style={{
                      padding: '8px 16px',
                      borderRadius: 20,
                      cursor: 'pointer',
                      backgroundColor:
                        activeWarehouseId === null ? '#FFBE00' : '#F5F7FB',
                      color: activeWarehouseId === null ? '#fff' : '#1C2A53',
                      fontSize: 13,
                      fontWeight: 500,
                    }}>
                    Всі склади
                  </div>
                </div>
              )}

              <div style={{position: 'relative'}}>
                <div
                  onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}
                  style={{
                    padding: '8px 16px',
                    borderRadius: 20,
                    cursor: 'pointer',
                    backgroundColor: currentStatus.bg,
                    color: currentStatus.color,
                    fontSize: 13,
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    minWidth: 140,
                    justifyContent: 'space-between',
                  }}>
                  <span>{currentStatus.label}</span>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    style={{
                      transform: isStatusDropdownOpen
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                      transition: 'transform 0.2s',
                    }}>
                    <path
                      d="M3 4.5L6 7.5L9 4.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {isStatusDropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 'calc(100% + 4px)',
                      right: 0,
                      backgroundColor: '#fff',
                      borderRadius: 12,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                      minWidth: 180,
                      zIndex: 100,
                      overflow: 'hidden',
                    }}>
                    {statusOptions.map(status => (
                      <div
                        key={status.id}
                        onClick={() => {
                          setActiveStatusId(status.id);
                          setIsStatusDropdownOpen(false);
                        }}
                        style={{
                          padding: '10px 16px',
                          cursor: 'pointer',
                          backgroundColor:
                            activeStatusId === status.id ? status.bg : '#fff',
                          color: status.color,
                          fontSize: 13,
                          fontWeight: 500,
                          transition: 'background-color 0.2s',
                        }}
                        onMouseEnter={e => {
                          if (activeStatusId !== status.id) {
                            e.currentTarget.style.backgroundColor = '#F5F7FB';
                          }
                        }}
                        onMouseLeave={e => {
                          if (activeStatusId !== status.id) {
                            e.currentTarget.style.backgroundColor = '#fff';
                          }
                        }}>
                        {status.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div
              className={`dashboard-card ${
                warehouseman?.loading ||
                warehouseman?.error ||
                warehouseman?.is_no_access
                  ? classes.itemDisabled
                  : classes.item
              }`}>
              {warehouseman?.loading ? (
                <div
                  className="dashboard-card-empty"
                  style={{height: '10vh !important'}}>
                  <Preloader />
                </div>
              ) : warehouseman?.error ? (
                <div
                  className="dashboard-card-empty"
                  style={{height: '10vh !important'}}>
                  {t('common:unknown_error_label')}
                </div>
              ) : warehouseman?.is_no_access ? (
                <div
                  className="dashboard-card-empty"
                  style={{height: '10vh !important'}}>
                  {t('common:storekeeper_access_label')}
                </div>
              ) : null}
              <div className={classes.header}>
                <h2 className="dashboard-title">
                  {t('common:store_instruction')}
                </h2>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[lang]}>
                  <DatePicker
                    key={
                      isRangeMode
                        ? `range-${startDate}-${endDate}`
                        : `single-${valueDate}`
                    }
                    className={`${classes.datePicker} ${classes.customDateInput}`}
                    disableToolbar
                    autoOk
                    format="dd.MM.yyyy"
                    maxDate={moment()}
                    variant="inline"
                    value={isRangeMode ? startDate : valueDate || moment()}
                    onChange={handleDateChange}
                    inputProps={{
                      readOnly: true,
                      value: getDisplayValue(),
                    }}
                    InputProps={{
                      value: getDisplayValue(),
                      readOnly: true,
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div
                className={
                  !warehouseman?.loading &&
                  !warehouseman?.error &&
                  !warehouseman?.is_no_access &&
                  filteredOrders?.length < 1
                    ? classes.tableDisabled
                    : classes.table
                }>
                {!warehouseman?.loading &&
                !warehouseman?.error &&
                !warehouseman?.is_no_access &&
                filteredOrders?.length < 1 ? (
                  <div
                    className="dashboard-card-empty"
                    style={{
                      padding: '0 !important',
                      marginY: 'auto',
                      marginX: 'auto',
                    }}>
                    {t('common:missing_orders_by_date')}
                  </div>
                ) : (
                  filteredOrders?.length > 0 && (
                    <Table
                      className="dashboard-table"
                      aria-label="full width table">
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>№ {t('common:orders')}</TableCell>
                          <TableCell>{t('common:warehouse')}</TableCell>
                          <TableCell>{t('common:delivery')}</TableCell>
                          <TableCell>{t('common:date_form')}</TableCell>
                          <TableCell>{t('common:date_delivery')}</TableCell>
                          <TableCell>
                            {t('common:orderTableHeaderLabelStatus')}
                          </TableCell>
                          <TableCell>{t('common:actions_label')}</TableCell>
                        </TableRow>
                      </TableHead>
                      {filteredOrders.length > 0 &&
                        filteredOrders.map((item, index) => (
                          <Row key={`order-${index}`} data={item} />
                        ))}
                      {/* {warehouseman?.orders && warehouseman?.orders?.length > 0
                    ? warehouseman?.orders?.map((item, index) => (
                        <Row key={`order-${index}`} data={item} />
                      ))
                    : [1, 2, 3]?.map((item, index) => (
                        <Row
                          key={`order-${index}`}
                          data={{
                            id: item,
                            order_items: [],
                            delivery: 'Доставка',
                            created: '12-07-2024',
                            status_name: {
                              id: 3,
                              name: 'В обробці',
                            },
                            remark: {},
                            payment: '',
                            return_delivery: '',
                          }}
                        />
                      ))} */}
                    </Table>
                  )
                )}
              </div>
            </div>
          </DashboardAnimate>
        </div>
      </div>
    </main>
  );
};

function mapState(state) {
  const {warehouseman, userSelectedData} = state;
  return {
    warehouseman,
    userSelectedData,
  };
}

const actionCreators = {
  getWarehouseman: userActions.getWarehouseman,
};

export default connect(mapState, actionCreators)(DashboardStorekeeper);
